import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';

export default makeStyles<NextTheme>(theme => ({
  label: {
    fontSize: 14,
    marginLeft: theme.spacing(1),
  },
}));
